export default "__VITE_ASSET___IzPfeYx__"